import type { ReceiptAudit } from '../../services/auditService';
import { formatUtcAssumedDateTimeMMDDYYYY } from '../../utils/formatUtils';
import {
  resolveNonTicketReportDate,
  resolveNonTicketReportTime,
} from '../../features/audit/fixOcr/utils/nonTicketReportDateUtils';

export const formatReceiptAuditTimestamp = (dateString: string): string => {
  return formatUtcAssumedDateTimeMMDDYYYY(dateString, { withSeconds: true });
};

const resolveReportType = (audit: ReceiptAudit): string => {
  const finalJson = (audit as any)?.parsed_data?.final_json;
  return String((audit as any)?.report_type || finalJson?.report_type || '').toLowerCase();
};

const resolveFinalJson = (audit: ReceiptAudit): any => (
  (audit as any)?.parsed_data?.final_json ?? {}
);

export const getReceiptAuditShiftDate = (audit: ReceiptAudit): string => {
  return resolveNonTicketReportDate(
    resolveReportType(audit),
    resolveFinalJson(audit),
    audit,
  ) || 'N/A';
};

export const getReceiptAuditShiftDateSortValue = (audit: ReceiptAudit): string => {
  const displayDate = getReceiptAuditShiftDate(audit);
  return displayDate === 'N/A' ? '' : displayDate;
};

export const getReceiptAuditShiftStartTime = (audit: ReceiptAudit): string => {
  return resolveNonTicketReportTime(
    resolveReportType(audit),
    resolveFinalJson(audit),
    audit,
  ) || 'N/A';
};

export const getReceiptAuditShiftTime = (audit: ReceiptAudit): string => {
  return getReceiptAuditShiftStartTime(audit);
};

export const isReceiptAuditProcessedStatus = (status: string): boolean => {
  const normalizedStatus = String(status || '').toLowerCase();
  return normalizedStatus === 'finalized' || normalizedStatus === 'auto_finalized' || normalizedStatus === 'auto_created';
};

export const formatReceiptAuditStatusLabel = (status: string): string => {
  const normalizedStatus = String(status || '').trim();
  if (!normalizedStatus) {
    return 'Unknown';
  }

  return normalizedStatus
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
